import { useContext } from 'react';
import { AppContext } from '../../App';
import React, { createElement, Fragment, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { ContactSearchResult } from '../ContactSearch/ContactSearchResult';
import './Autocomplete.css'

export interface IAutocompleteProps<T> {
    detached?: string;
    openOnFocus?: boolean;
    sourceId: string;
    indexName: string;


    //itemTemplate(onSelect: (data: T) => void): ({ item, components } : { item: T, components: any }) => JSX.Element;

    itemTemplate({ item, components } : { item: T, components: any }): JSX.Element;
}

export const Autocomplete = <T,>(props: IAutocompleteProps<T>) => {
    const { searchClient } = useContext(AppContext);
    return (
        <AutocompleteContainer
            detachedMediaQuery={props.detached ? '' : undefined}
            openOnFocus={props.openOnFocus ?? true}
            getSources={({ query } : { query: any }) => [
                {
                    sourceId: props.sourceId,
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: props.indexName,
                                    query,
                                },
                            ],
                        });
                    },
                    templates: {
                        item: props.itemTemplate
                    },
                },
            ]}
        />
    );
}




export function ProductItem({ hit, components } : { hit: any, components: any }) {

    return (<ContactSearchResult contact={hit} />)

    return (
      <a href={hit.url} className="aa-ItemLink" style={{ zIndex: "10001" }}>
        <div className="aa-ItemContent" style={{ backgroundColor: "#FFFFFF" }}>
          <div className="aa-ItemTitle">
            <components.Highlight hit={hit} attribute="name" />
          </div>
        </div>
      </a>
    );
  }

const AutocompleteContainer = (props: any) => {

    const containerRef = useRef<any>(null);
    const panelRootRef = useRef<any>(null);
    const rootRef = useRef<any>(null);

    useEffect(() => {

        if (!containerRef.current) {
            return undefined;
        }

        const search = autocomplete({

            container: containerRef.current,

            renderer: { createElement, Fragment, render: () => {} },

            render({ children }, root) {

                if (!panelRootRef.current || rootRef.current !== root) {
                    rootRef.current = root;
                    panelRootRef.current?.unmount();
                    panelRootRef.current = createRoot(root);
                }

                panelRootRef.current.render(children);

            },
            ...props,

        });

        containerRef.current.focus();

        return () => {
            search.destroy();
        };

    }, [props]);

    return <div ref={containerRef} />;

}